import React from "react";
import { Button, Divider, List } from "antd";
import FilesUpload from "nbugs-files-upload";
import { ENV } from "@/services/utils";
import styles from "./EvaluationDetail.less";

const { Item } = List;

function EvaluationDetail({
  score,
  remark,
  appendix,
  goBack,
  approved,
  reportUser,
  templateType = 1,
  reRender
}) {
  const handleClick = () => {
    goBack();
  };

  return (
    <div className={styles.evaluationDetail}>
      <div className="evaluationDetailTitle">
        <Divider orientation="left">专家评估</Divider>
      </div>
      {reRender && (
        <div className="evaluationDetailNews">
          {(templateType === 1 || templateType === 2) && (
            <Item>
              <span className="itemName">评估分数</span>
              <span style={{ marginLeft: 16 }}>{score || 0}分</span>
            </Item>
          )}
          <Item>
            <span className="itemName">
              {templateType === 3 ? "审核人员" : "评估人"}
            </span>
            <span style={{ marginLeft: 16 }}>{reportUser || '-'}</span>
          </Item>
          <Item>
            <span className="itemName">
              {templateType === 3 ? "审核说明" : "评估说明"}
            </span>
            <span style={{ marginLeft: 16 }}>{remark || '-'}</span>
          </Item>
          {templateType === 3 && (
            <Item label="审核状态">
              <span className="itemName">审核状态</span>
              <span style={{ marginLeft: 16 }}>
                {approved === 1 ? "通过" : "驳回"}
              </span>
            </Item>
          )}
          {(templateType === 1 || templateType === 2) && (
            <Item>
              <span className="itemName">评估附件</span>:
              <div className="fieldsUpload" style={{ marginLeft: 16 }}>
                {appendix ? (
                  <FilesUpload
                    edit={1}
                    type="pc"
                    APIEnv={ENV}
                    groupId={appendix}
                    previewUrl={`//${window.location.hostname}/v2/preview/file`}
                  />
                ) : (
                  <span style={{lineHeight:'27px'}}>-</span>
                )}
              </div>
            </Item>
          )}
          {/* {templateType === 2 && (
            <Item {...tailFormItemLayout}>
              <Checkbox checked={!!wetherRealPatrol}>
                已加入实地核查计划
              </Checkbox>
            </Item>
          )} */}
          <Item>
            <Button onClick={handleClick}>返回</Button>
          </Item>
        </div>
      )}
    </div>
  );
}

export default EvaluationDetail;
